import { createContext, useContext } from 'react';

import type { OmnibarEligibilityResult } from './hooks/useOmnibarEligibility.ts';

const defaultEligibility: OmnibarEligibilityResult = {
	showReactions: false,
	showComments: false,
};

/**
 * Context for OmniBar eligibility so the experiment is read only once (in ViewPageCommon).
 */
export const OmnibarEligibilityContext =
	createContext<OmnibarEligibilityResult>(defaultEligibility);

export const OmnibarEligibilityProvider = OmnibarEligibilityContext.Provider;

export const useOmnibarEligibilityFromContext = (): OmnibarEligibilityResult =>
	useContext(OmnibarEligibilityContext);
